import { useDeal } from '../../hooks/useDeal';
import { useUIStore } from '../../store/ui';
import { CenterTabs } from './CenterTabs';
import { OverviewTab } from './tabs/OverviewTab';
import { TitleTab } from './tabs/TitleTab';
import { CompsTab } from './tabs/CompsTab';
import { PackageTab } from './tabs/PackageTab';
import { ActivityTab } from './tabs/ActivityTab';

interface Props { dealId: string; }

export function CenterColumn({ dealId }: Props) {
  const { centerTab } = useDeal(dealId);
  const setCenterTab = useUIStore(s => s.setCenterTab);

  return (
    <main className="col-center">
      <CenterTabs
        dealId={dealId}
        activeTab={centerTab}
        onChangeTab={t => setCenterTab(dealId, t)}
      />
      <div className="center-content">
        {centerTab === 'overview'      && <OverviewTab dealId={dealId} />}
        {centerTab === 'title'         && <TitleTab dealId={dealId} />}
        {centerTab === 'comps'         && <CompsTab dealId={dealId} />}
        {centerTab === 'package'       && <PackageTab dealId={dealId} />}
        {centerTab === 'activity'      && <ActivityTab dealId={dealId} />}
      </div>
    </main>
  );
}
